import { render, staticRenderFns } from "./Quick.vue?vue&type=template&id=a1f922f2&"
import script from "./Quick.vue?vue&type=script&lang=js&"
export * from "./Quick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports